module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }